import type { QueryClient } from "@tanstack/react-query";
import { infractionQueryKeys } from "./infraction-query-keys";

export function invalidateInfractionListQueries(
	queryClient: QueryClient
): void {
	queryClient.invalidateQueries({ queryKey: infractionQueryKeys.summary() });
	queryClient.invalidateQueries({
		queryKey: [...infractionQueryKeys.all, "paginated"],
	});
}

export function invalidateInfractionDetailQueries(
	queryClient: QueryClient
): void {
	queryClient.removeQueries({
		queryKey: [...infractionQueryKeys.all, "detail"],
	});
}
